// Spor sayfası giriş yapmadan görülebilir mi.
//
// Karar **tek yerdedir** ve bütün spor kaynakları için aynıdır: sitenin kendi
// oran beslemesi, Betby (SynCode) ve Flexrix. Sayfa başına kopyalansaydı
// hazır spor kitabı misafire açılırken sitenin kendi sportsbook'u kapalı
// kalır (ya da tersi) ve aynı ayar iki farklı şey söylerdi.
//
// Misafir modu bir **izleme** modudur: oranlar görünür, kupon için giriş
// gerekir — asıl kapı sunucudadır (bkz. backend/services/sports_access.py),
// buradaki kontrol yalnızca ziyaretçinin açılmayan bir sayfaya gitmesini
// önler.
//
// Varsayılan **açıktır**: ayar yanıtı gelmeden ya da alan hiç yazılmamışken
// değer tanımsızdır ve kapalı sayılsaydı sayfa her açılışta bir an için
// "giriş yapın" derdi. Kapatma yalnızca açık bir `false` ile olur.
export const sportsGuestViewAllowed = (settings) => (
  settings?.sports_guest_view_enabled !== false
);

export default sportsGuestViewAllowed;
